import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface ModalState {
  value: any;
}

const initialState: ModalState = {
  value: null,
};

// modal/openModal
// modal/closeModal
export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<any>) => {
      const { modalType, modalProps } = action.payload;
      state.value = action.payload;
      // console.log(state.value);
    },
    closeModal: (state) => {
      state.value = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export const getModalState = (state: RootState) => state.modal.value;
export default modalSlice.reducer;
